<app-nav-pages></app-nav-pages>
<section class="hero-section d-flex justify-content-center align-items-center csr-hero position-relative flex-column  "></section>

<section class="container mt-5 mb-5 queen_intro d-flex align-items-center justify-content-center flex-column ">
  <h2 class="text-center mb-5" #textContent>QUEEN IDIA RESIDENCE</h2>
  <h3 class="text-center queen_slogan" #textContent>"NEIGHBORHOOD FOR THE BRAVE"</h3>
  <div class="queen_text text-center w-75" #textContent>
    <p>Renowned for her groundbreaking achievements in reshaping the boundaries of feminine prowess, the graceful and courageous Queen Idia has inspired Zumera Property to create a residence for those who have demonstrated expertise and bravery in their respective fields, making a transformative impact on the global space.

      Whether in the Diaspora or on a Quest for Greatness, these individuals aspire to uplift their family's legacy and carve out a name for themselves.</p>
    
  </div>

</section>

<section class="container announcement" #textContent>
  <div class="hero-text text-center">
    <h2>
      When Developed, Queen Idia Residence will be the only residence in Benin City Approved by His Royal Majesty, Omo N'Oba N'Edo, Uku Akpolokpolo Oba Ewuare II.
    </h2>
  </div>
</section>

<section class="flex-column">
  <div class="container">
    <div class="our_project_header ">
      <h2 class="text-center ">Other Projects You May Like</h2>
      <h2 class="welcome_mssg mssg_2 " >Crafting The Highest Standard, Innovative Products and The Most Valuable Environments For You.</h2>
    </div>
    <div class="our_project  mx-auto ">
      <div id="ourProjects" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner our_project_carousel_inner mx-auto ">
          <div class="carousel-item active">
            <img src="assets/imgs/facade_2.jpg" class="d-block w-100" alt="...">

            <div class="know-more d-flex justify-content-between align-items-center  ">
              <h3 class="rdj_bold"><b>ZUMERA TOWER.</b></h3>
              
              <a href="https://zumeratower.com" class="know-more-btn" (mouseenter)="onMouseColorChange('white')" (mouseleave)="onChangeColorBack('#8d0a1f')">KNOW MORE</a>
            </div>
          </div>
          <div class="carousel-item">
            <img src="assets/imgs/project-1.jpg" class="d-block w-100" alt="...">

            <div class="know-more d-flex justify-content-between align-items-center ">
              <h3 class="rdj_bold"><b>THE ULTIMATE ELITES RESIDENCE (LIMITED EDITION). </b></h3>
              
              <a href="https://zumeraproperty.com/projects/Elites-Residence" class="know-more-btn" (mouseenter)="onMouseColorChange('white')" (mouseleave)="onChangeColorBack('#8d0a1f')">KNOW MORE</a>
            </div>
          </div>
        </div>


        <button class="carousel-control-prev" type="button" data-bs-target="#ourProjects" data-bs-slide="prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-chevron-left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
          </svg>
          <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span> -->
          <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#ourProjects" data-bs-slide="next">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="black" class="bi bi-chevron-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
          </svg>
          <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</section>
<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>